import Vue from "vue";
import moment from "moment";

Vue.filter("moment", function(timestamp, format) {
  return moment(timestamp.toDate()).format(format);
});

Vue.filter("YYYYMMDDHHMM", function(timestamp) {
  const format = "YYYY/MM/DD hh:mm";
  return moment(timestamp.toDate()).format(format);
});
